// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__ETO+F","above":"Footer_above__SF028","left":"Footer_left__aLZA+","right":"Footer_right__ts+rg","below":"Footer_below__BWX+O"};